import React from "react";
import Tetris from "react-tetris";

const TetrisModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-stone-800 rounded shadow-lg p-6 max-w-md w-full">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-center text-gray-800 dark:text-gray-100">
            Play DLM Tetris
          </h2>
          <button
            onClick={onClose}
            className="text-gray-600 dark:text-gray-400 hover:text-black dark:hover:text-white"
          >
            ✖
          </button>
        </div>
        <div className="flex flex-col items-center relative">
          <div className="absolute top-0 right-0 p-2">
            <div className="group relative">
              <button
                className="text-sm px-2 py-1 bg-gray-200 dark:bg-gray-700 text-black dark:text-white rounded shadow hover:bg-gray-300 dark:hover:bg-gray-600"
                aria-label="Instructions"
              >
                ?
              </button>
              <div className="absolute hidden group-hover:block bg-white dark:bg-stone-700 text-gray-900 dark:text-gray-100 text-sm rounded shadow-lg p-4 w-60 z-10">
                <p className="mb-2 font-bold">Controls</p>
                <ul className="list-disc pl-4">
                  <li><b>←</b>: Move Left</li>
                  <li><b>→</b>: Move Right</li>
                  <li><b>↓</b>: Move Down</li>
                  <li><b>Space</b>: Hard Drop</li>
                  <li><b>Z</b>: Rotate Counterclockwise</li>
                  <li><b>X</b> or <b>↑</b>: Rotate Clockwise</li>
                  <li><b>C</b> or <b>Shift</b>: Hold</li>
                  <li><b>P</b>: Pause</li>
                </ul>
              </div>
            </div>
          </div>
          <Tetris
            keyboardControls={{
              down: "MOVE_DOWN",
              left: "MOVE_LEFT",
              right: "MOVE_RIGHT",
              space: "HARD_DROP",
              z: "FLIP_COUNTERCLOCKWISE",
              x: "FLIP_CLOCKWISE",
              up: "FLIP_CLOCKWISE",
              p: "TOGGLE_PAUSE",
              c: "HOLD",
              shift: "HOLD",
            }}
          >
            {({
                Gameboard,
                points,
                linesCleared,
                state,
                controller,
              }) => (
              <div className="flex flex-col items-center">
                <Gameboard
                  style={{
                    display: "grid",
                    gridTemplateRows: "repeat(20, 20px)",
                    gridTemplateColumns: "repeat(10, 20px)",
                    gap: "1px",
                    backgroundColor: "#000",
                    border: "2px solid #555",
                  }}
                />
                <div className="mt-4 text-center">
                  <p className="text-gray-800 dark:text-gray-200">
                    <b>Points:</b> {points}
                  </p>
                  <p className="text-gray-800 dark:text-gray-200">
                    <b>Lines Cleared:</b> {linesCleared}
                  </p>
                  {state === "LOST" && (
                    <div className="text-center mt-4">
                      <h2 className="text-lg font-semibold text-red-500 dark:text-red-400">
                        Game Over! YOU SUCK!
                      </h2>
                      <button
                        onClick={controller.restart}
                        className="mt-2 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-700"
                      >
                        New Game
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )}
          </Tetris>
        </div>
      </div>
    </div>
  );
};

export default TetrisModal;
